const routes = [
  {
    path: '/face-recognition-result',
    name: 'Face Recognition Result',
    meta: {
      title: 'Face Recognition Result',
      layout: 'face-recognition-result'
    },
    component: () => import(/* webpackChunkName: "faceRecognitionResult" */ '../views/prakerja/FaceRecognitionResult.vue')
  }
]

export default routes
